export default __webpack_public_path__ + "static/media/ct-logo.ffc84040.svg";